import { GuardData } from './guard.model';

const guestGuard = (guardData: GuardData): boolean => {
  return !guardData.store.auth.session;
};

export default guestGuard;